// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal-4vret","header":"header-28TXM","body":"body-1QVuY","footer":"footer-25yTG","title":"title-3xxly"};